import { FC } from 'react';

import { usePage } from '@inertiajs/react';

import { useResolvedTheme } from '../../hooks/useResolvedTheme';
import { Expansion, ProductType, Universe } from '../../types';

type PageProps = {
    currentUniverse: Universe;
    currentProductType: ProductType;
    currentExpansion: Expansion | null;
    releaseHighlights: Expansion[];
};

export const MobileBanner: FC = () => {
    const resolvedTheme = useResolvedTheme();
    const {
        currentUniverse,
        currentProductType,
        currentExpansion,
        releaseHighlights,
    } = usePage<PageProps>().props;
    const heroBanner =
        resolvedTheme === 'dark'
            ? currentUniverse.hero_banner_dark
            : currentUniverse.hero_banner;

    const heroBannerStyle = heroBanner
        ? {
              backgroundImage: `url(${heroBanner})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
          }
        : undefined;

    if (currentProductType || currentExpansion) {
        return (
            <section className={`block bg-muted/30 py-4 md:hidden`}>
                <div className="container">
                    <div className="flex flex-col justify-between gap-4 md:flex-row">
                        <div>
                            {currentProductType && currentExpansion ? (
                                <h1 className="text-xl font-bold">
                                    {currentProductType.name}{' '}
                                    {currentExpansion.name} —{' '}
                                    {currentUniverse.name}
                                </h1>
                            ) : currentProductType ? (
                                <h1 className="text-xl font-bold">
                                    {currentProductType.name}{' '}
                                    {currentUniverse.name}
                                </h1>
                            ) : (
                                <>
                                    <h1 className="text-xl font-bold">
                                        {currentUniverse.name}
                                    </h1>
                                    <p className="text-muted-foreground">
                                        {currentUniverse.description}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        );
    } else if (!releaseHighlights?.length) {
        return (
            <section
                className={`relative block h-[7.5rem] py-8 md:hidden md:py-12 ${heroBanner ? 'bg-background' : 'bg-muted/30'}`}
                data-testid="mobile-hero-banner"
            >
                {heroBanner && (
                    <div
                        className="pointer-events-none absolute inset-0 opacity-25 dark:opacity-20"
                        data-testid="mobile-hero-banner-image"
                        style={heroBannerStyle}
                    />
                )}
                <div className="relative z-10 container flex h-full items-center px-4">
                    <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
                        <div className="flex items-center gap-4">
                            <div className="text-foreground">
                                <h1 className="text-2xl font-bold md:text-3xl">
                                    {currentUniverse.name}
                                </h1>
                                <p className="mt-1 max-w-lg text-sm text-foreground/70 md:text-base">
                                    {currentUniverse.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return null;
};
